exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-0981baf1]::after,\nlabel[data-v-0981baf1]::after {\n  content: '*';\n  color: red;\n  margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-0981baf1] {\n  font-weight: 100;\n  color: red;\n  position: initial;\n  text-align: left;\n  height: auto;\n  width: auto;\n}\n.has-danger[data-v-0981baf1] {\n  color: red;\n}\n.swal2-popup[data-v-0981baf1] {\n  font-size: 2rem !important;\n}\n.gradientbt[data-v-0981baf1] {\n  color: white;\n  background: #0F6940;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0981baf1","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/device/DeviceDetail.vue
// module id = 120
// module chunks = 0